<template>
  <ModalConfirm :open="open" @update:open="updateOpen" :title="`Report This ${reportableType}`" level="warning" require-message
                description="The information you provide is reviewed by Business Draft and handled with utmost confidentiality. Please note, any misuse of this feature may lead to account suspension."
                proceed-button-text="Report" message-label="Reason" v-model:message="report.description"
                message-placeholder="I am reporting this message because..."
                :message-validation-callback="() => validateReport" @confirm="storeIncidentReport"
                incomplete-message-warning="Messages cannot be blank">
    <div class="mt-6 mb-3 space-y-1.5">
      <BorderGradient v-for="reason in REASONS" :key="reason.value" @click="report.reasons = reason.value"
                      :border-radius="0.5" :hide-gradient="reason.value !== report.reasons"
                      hidden-gradient-class="bg-slate-200">
        <div class="cursor-pointer px-4 py-2" :class="reason.value === report.reasons && 'font-bold'">
          {{ reason.label }}
        </div>
      </BorderGradient>
    </div>
  </ModalConfirm>
</template>
<script setup>
import BorderGradient from "./BorderGradient.vue";
import IncidentReportApi from "../api/IncidentReportApi.js";
import ModalConfirm from "./ModalConfirm.vue";
import {reactive} from "vue";

const emits = defineEmits(["update:open"]);
const props = defineProps({
  open: Boolean,
  reportableId: Number,
  reportableType: {
    type: String,
    validator: (value) => ["Message", "Candidate", "Company", "Conversation", "Opportunity"].includes(value),
  },
  companyId: Number,
});

const REPORT_REASON_HARASSMENT = "harassment";
const REPORT_REASON_INAPPROPRIATE = "inappropriate";
const REPORT_REASON_SPAM = "spam";
const REPORT_REASON_OTHER = "other";

const REASONS = [
  {label: "Harassment", value: REPORT_REASON_HARASSMENT},
  {label: "Inappropriate", value: REPORT_REASON_INAPPROPRIATE},
  {label: "Spam", value: REPORT_REASON_SPAM},
  {label: "Other", value: REPORT_REASON_OTHER},
];

const report = reactive({
  description: "",
  reasons: REPORT_REASON_HARASSMENT,
});


const storeIncidentReport = async () => {
  await new IncidentReportApi()
    .create({
      reportable_id: props.reportableId,
      reportable_type: props.reportableType,
      reasons: report.reasons,
      description: report.description,
      company_id: props.companyId,
    })
    .then(() => {
      toast.success("Sent! Thank you for helping us keep our community safe.");
      updateOpen(false);
    });
};

const validateReport = () => {
  if (report.description.length < 10) return "Please provide a more detailed explanation.";
  if (!REASONS.includes(report.reasons)) return "Please select a reason.";
  return true;
};

const updateOpen = (shouldBeOpen) => emits("update:open", shouldBeOpen);
</script>
